<template>
  <USlideover
    v-model:open="drawerState.isOpen"
    title=" "
    description=" "
    :ui="{
      content: 'max-w-fit'
    }"
  >
    <template #content>
      <div class="flex flex-col w-full h-full">

        <div class="flex items-center justify-end sm:justify-start gap-1.5 p-4 sm:px-6 min-h-16 border-b border-muted">
          <ButtonFunctional type="close" @click="closeDrawer" />
        </div>

        <div class="flex-1 overflow-y-auto p-4 sm:p-6">
          <component
            :is="getBlockByType()"
            :id="drawerState.entityId"
            ref="formComponent"
            :is-editing="isEditing"
            @loading="loading = $event"
            @changed="isChanged = $event"
            @editing="isEditing = $event"
          />
        </div>

        <div
          class="flex items-center gap-3 border-t border-muted"
          :class="isMobile ? 'p-4 md:pb-[calc(1rem+64px)] sm:px-6' : 'p-4 sm:px-6'"
        >
          <Button :disabled="!isChanged || loading" @click="submitForm">{{ t('ui.drawer.btnSaveTitle') }}</Button>
          <Button outline @click="closeDrawer">{{ t('ui.drawer.btnCloseTitle') }}</Button>
        </div>

      </div>
    </template>
  </USlideover>
</template>

<script setup lang="ts">
  import { useGlobalStore } from '~/stores/useGlobalStore'
  import { isMobile } from '~/helpers/breakpoints'
  import UpdateUserData from '~/components/auth/update-userdata-form/index.vue'
  import ChangePasswordForm from '../auth/change-password-form/index.vue'
  import WareHouseman from '../warehouseman/warehouseman-form/index.vue'
  import ServiceList from '~/components/warehouse-task/current/service-list/index.vue'
  import ButtonFunctional from '../ui/button/functional.vue'
  import Button from '../ui/button/index.vue'

  const { drawerState } = storeToRefs(useGlobalStore())

  const formComponent = ref()
  const loading = ref(false)
  const isChanged = ref(false)
  const isEditing = ref(true)
  const { t } = useI18n()

  const closeDrawer = () => {
    if (isEditing.value) {
      const message = isChanged.value
        ? t('forms.confirm.changed')
        : t('forms.confirm.close')

      // if (message && !confirm(message)) return
    }

    isChanged.value = false
    // isEditing.value = true
    drawerState.value.isOpen = false
    formComponent.value?.onClose?.()
  }

  async function submitForm() {
    const success = await formComponent.value?.onSave()
    if (success) {
      isChanged.value = false
      // isEditing.value = true
      drawerState.value.isOpen = false
    }
  }

  const getBlockByType = () => {
    switch (drawerState.value.formType) {
      case 'changePassword':
        return ChangePasswordForm
      case 'updateUserData':
        return UpdateUserData
      case 'warehousemanForm':
        return WareHouseman
      case 'updateServices':
        return ServiceList
    }
  }
</script>
